<div class="sentiment-analysis__summary-row">
  <div class="sentiment-analysis__summary-col sentiment-analysis__summary-col--narrow">
    <app-sentiment-actionable-comments-card
      [count]="actionableComments"
      [label]="'Actionable comments'"
    ></app-sentiment-actionable-comments-card>
  </div>
  <div class="sentiment-analysis__summary-col sentiment-analysis__summary-col--mid">
    <app-sentiment-overview-widget
      [sentiment]="sentimentData"
      [npsScore]="npsScore"
      [sentimentScore]="sentimentScore"
      [ratingOverview]="ratingOverview ?? null"
    ></app-sentiment-overview-widget>
  </div>
  <div class="sentiment-analysis__summary-col sentiment-analysis__summary-col--wide">
    <app-sentiment-theme-distribution-widget
      [stats]="stats"
      [sentimentFilter]="sentimentFilter"
      (sentimentFilterChange)="onSentimentFilter($event)"
      [viewMode]="viewMode"
      (viewModeChange)="onViewMode($event)"
    ></app-sentiment-theme-distribution-widget>
  </div>
</div>
